export default __webpack_public_path__ + "static/media/modal-image-email.30838bff.webp";